import { ref } from 'vue'

// 邀请入口只接受当前端可用的邀请好友2.0活动，关闭、过期及请求失败时隐藏。
export function useInvitationEntry({ getToken, fetchActivities }) {
  const activity = ref(null)
  let version = 0

  function clear() {
    version += 1
    activity.value = null
  }

  async function load() {
    const token = getToken()
    const requestVersion = ++version
    activity.value = null
    if (!token) return null
    try {
      const items = await fetchActivities({ activityType: 'INVITE_FRIEND_V2' })
      if (requestVersion !== version || token !== getToken()) return null
      activity.value = (items || []).find(item => item.activityType === 'INVITE_FRIEND_V2' && item.status === 1) || null
      return activity.value
    } catch {
      return null
    }
  }

  return { activity, load, clear }
}
